(function () {
  const ROOT_SELECTOR = '[data-bps-product-closer-look]';
  const GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
  const SCROLL_TRIGGER_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);

      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.dataset.bpsCloserLookDependency = 'true';
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) {
      return Promise.resolve();
    }

    if (!window.BPSCloserLookGsapPromise) {
      window.BPSCloserLookGsapPromise = loadScript(GSAP_URL).then(() => loadScript(SCROLL_TRIGGER_URL));
    }

    return window.BPSCloserLookGsapPromise;
  }

  function scrollToBuyBox(root) {
    const productSection = document.querySelector('[data-section-type="product"]');

    if (!productSection) {
      return;
    }

    const top = productSection.getBoundingClientRect().top + window.scrollY - 86;
    window.scrollTo({ top, behavior: 'smooth' });

    const sizeInput = productSection.querySelector('input[type="radio"]:not([disabled]), select, button[name="add"]');

    window.setTimeout(() => {
      if (sizeInput && typeof sizeInput.focus === 'function') {
        sizeInput.focus({ preventScroll: true });
      }
    }, 520);
  }

  function initRoot(root) {
    if (!root || root.dataset.bpsCloserLookInitialized === 'true') {
      return;
    }

    root.dataset.bpsCloserLookInitialized = 'true';

    const buyButton = root.querySelector('[data-bps-closer-look-buy]');
    if (buyButton) {
      buyButton.addEventListener('click', () => scrollToBuyBox(root));
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      root.classList.add('is-bps-cl-ready');
      return;
    }

    ensureGsap().then(() => {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;

      if (!gsap || !ScrollTrigger) {
        root.classList.add('is-bps-cl-ready');
        return;
      }

      gsap.registerPlugin(ScrollTrigger);
      root.classList.add('is-bps-cl-ready', 'is-bps-cl-gsap');

      const revealItems = root.querySelectorAll('[data-bps-cl-animate]');
      if (revealItems.length) {
        gsap.fromTo(revealItems, {
          autoAlpha: 0,
          y: 34
        }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.86,
          ease: 'power3.out',
          stagger: 0.12,
          scrollTrigger: {
            trigger: root,
            start: 'top 72%'
          }
        });
      }

      const images = root.querySelectorAll('[data-bps-cl-image]');
      if (images.length) {
        gsap.fromTo(images, {
          autoAlpha: 0,
          scale: 0.94,
          y: 38
        }, {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          stagger: 0.12,
          scrollTrigger: {
            trigger: root.querySelector('[data-bps-cl-visual]') || root,
            start: 'top 78%'
          }
        });

        gsap.to(images[0], {
          yPercent: -7,
          scale: 1.035,
          ease: 'none',
          scrollTrigger: {
            trigger: root,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.75
          }
        });
      }

      const floatBadge = root.querySelector('[data-bps-cl-float]');
      if (floatBadge) {
        gsap.fromTo(floatBadge, {
          autoAlpha: 0,
          y: 22,
          rotate: -2
        }, {
          autoAlpha: 1,
          y: 0,
          rotate: 0,
          duration: 0.82,
          ease: 'back.out(1.5)',
          scrollTrigger: {
            trigger: floatBadge,
            start: 'top 88%'
          }
        });

        gsap.to(floatBadge, {
          yPercent: 14,
          ease: 'none',
          scrollTrigger: {
            trigger: root,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.8
          }
        });
      }

      const cards = root.querySelectorAll('[data-bps-cl-card]');
      cards.forEach((card, index) => {
        gsap.fromTo(card, {
          autoAlpha: 0,
          x: window.innerWidth < 750 ? 18 : 44,
          y: window.innerWidth < 750 ? 22 : 0
        }, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 0.78,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: card,
            start: 'top 82%'
          },
          delay: index * 0.06
        });
      });
    }).catch(() => {
      root.classList.add('is-bps-cl-ready');
    });
  }

  function init(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
